var _rect, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.892,
    width: 31.012,
    height: 30.705,
    rx: 4,
    fill: "#9C1A87"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.144,
    cy: 5.905,
    rx: 1.988,
    ry: 1.968,
    fill: "#150223"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.747 15.746c0 4.348-3.56 7.873-7.951 7.873-4.392 0-7.952-3.525-7.952-7.873 0-4.348 3.56-7.873 7.952-7.873 4.391 0 7.951 3.525 7.951 7.873zm-13.096 0c0 2.813 2.303 5.094 5.145 5.094 2.84 0 5.144-2.28 5.144-5.094 0-2.813-2.303-5.094-5.144-5.094-2.842 0-5.145 2.281-5.145 5.094z",
    fill: "#150223"
  })));
}
export default SvgInsta;